var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58204 4.856C7.72019 4.6169 8.02601 4.53506 8.26511 4.67321L12 6.83114L15.7349 4.67321C15.974 4.53506 16.2798 4.6169 16.418 4.856C16.5561 5.0951 16.4743 5.40092 16.2352 5.53907L12.2501 7.84153C12.0954 7.93095 11.9046 7.93095 11.7499 7.84153L7.76484 5.53907C7.52574 5.40092 7.4439 5.0951 7.58204 4.856Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59702 11.7546C3.73517 11.5155 4.04099 11.4336 4.28009 11.5718L8.26512 13.8742C8.41974 13.9636 8.51498 14.1286 8.51498 14.3072V18.9032C8.51498 19.1794 8.29112 19.4032 8.01498 19.4032C7.73883 19.4032 7.51498 19.1794 7.51498 18.9032V14.5957L3.77981 12.4376C3.54071 12.2995 3.45887 11.9937 3.59702 11.7546Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.403 11.7546C20.5411 11.9937 20.4593 12.2995 20.2202 12.4376L16.485 14.5957V18.9032C16.485 19.1794 16.2612 19.4032 15.985 19.4032C15.7089 19.4032 15.485 19.1794 15.485 18.9032V14.3072C15.485 14.1286 15.5803 13.9636 15.7349 13.8742L19.7199 11.5718C19.959 11.4336 20.2648 11.5155 20.403 11.7546Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83624 7.29107C3.97451 7.05204 4.28037 6.97036 4.5194 7.10863L12 11.4359L19.4806 7.10863C19.7196 6.97036 20.0255 7.05204 20.1637 7.29107C20.302 7.5301 20.2203 7.83597 19.9813 7.97424L12.2504 12.4463C12.0955 12.5359 11.9045 12.5359 11.7496 12.4463L4.01868 7.97424C3.77965 7.83597 3.69797 7.5301 3.83624 7.29107Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.5047C12.2761 11.5047 12.5 11.7285 12.5 12.0047V20.9311C12.5 21.2073 12.2761 21.4311 12 21.4311C11.7239 21.4311 11.5 21.2073 11.5 20.9311V12.0047C11.5 11.7285 11.7239 11.5047 12 11.5047Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4702 7.57282L12 3.4526L4.52979 7.57282V16.4366L12 20.5568L19.4702 16.4366V7.57282ZM20.4702 17.0271V6.98235L12 2.31058L3.52979 6.98235V17.0271L12 21.6989L20.4702 17.0271Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.83fbcf1986397dbd529e336b6a05f07d.svg";
export { ForwardRef as ReactComponent };